import quickFetch from 'quick-fetch';
import PortalIdParser from 'PortalIdParser';
import { DataFetchingClientProvider, DataFetchingClient } from 'data-fetching-client';
import { useEffect } from 'react';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import { Provider } from 'react-redux';
import { initTracker } from 'documents-lib/js/tracking/tracker';
import { getBrowserLanguage } from 'documents-lib/js/utils/getBrowserLanguage';
import { configureStore } from './utils/configureStore';
import { ViewApplication } from './containers/ViewApplication';
import { fetchPresentationSuccess, fetchDocumentsLegalConsentSuccess, documentsGDPRLangLoading } from './actions/DocumentsPublicActions';
import PresentationRecord from 'documents-lib/js/records/PresentationRecord';
import LegalConsentRecord from 'documents-lib/js/records/LegalConsentRecord';
import { ensureGdprLang } from './utils/ensureGdprLang';
import { needsToLoadLocale } from './utils/needsToLoadLocale';
import { jsx as _jsx } from "react/jsx-runtime";
function getPresentationEarlyData(store) {
  const presentationRequestState = quickFetch.getRequestStateByName('public-presentation');
  const presentationRequestReady = presentationRequestState && presentationRequestState.finished && !presentationRequestState.error;
  if (presentationRequestReady) {
    store.dispatch(fetchPresentationSuccess(PresentationRecord.create(presentationRequestState.data)));
    initTracker({
      isPublic: true
    });
  }
}
function getLegalConsentEarlyData(store) {
  const legalConsentRequestState = quickFetch.getRequestStateByName('public-legal-consent');
  if (!legalConsentRequestState) return;
  legalConsentRequestState.whenFinished(data => {
    store.dispatch(documentsGDPRLangLoading());
    const needsFallbackLocale = needsToLoadLocale(data);
    if (!needsFallbackLocale) {
      const consentRecord = LegalConsentRecord.fromJS(data);
      store.dispatch(fetchDocumentsLegalConsentSuccess(consentRecord));
    } else {
      ensureGdprLang(data).then(() => {
        const consentRecord = LegalConsentRecord.fromJS(data);
        store.dispatch(fetchDocumentsLegalConsentSuccess(consentRecord));
      }).catch(console.error);
    }
  });
  legalConsentRequestState.onError((xhr, message) => {
    console.error('Legal consent early request failed:', message);
  });
}
export const getLocaleInfo = () => {
  const browserLanguage = getBrowserLanguage();
  return {
    locale: browserLanguage,
    langEnabled: true
  };
};
export const prepareApp = () => {
  PortalIdParser.get();
  const store = configureStore({});
  getPresentationEarlyData(store);
  const dfcClient = new DataFetchingClient();
  return {
    props: {
      store,
      dfcClient
    }
  };
};
export function AppComponent({
  store,
  dfcClient
}) {
  useEffect(() => {
    setDocumentTitle('app.htmlTitle');
    getLegalConsentEarlyData(store);
  }, [store]);
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: dfcClient,
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(ViewApplication, {})
    })
  });
}